import { render, staticRenderFns } from "./CorpDetail.vue?vue&type=template&id=df8d9c74"
import script from "./CorpDetail.vue?vue&type=script&lang=js"
export * from "./CorpDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports